import xpath from 'xpath';
import * as x from '../helpers/xmlHelpers';
import { Services } from './service';
import { Signatories } from './signatories';
import { View } from './views';

export class AppraisalDocument {

    constructor(doc) {
        this.MISMOReferenceModelIdentifier = null;
        this.services = null;
        this.aboutVersions = [];
        this.documentClassification = null;
        this.signatories = null;
        this.views = [];
        var node;
        var nodes;
        
		var select = xpath.useNamespaces({"ns": "http://www.mismo.org/residential/2009/schemas"});

        var message = select("ns:MESSAGE", doc, true);
        this.MISMOReferenceModelIdentifier = x.getStringAttribute(message, "MISMOReferenceModelIdentifier");

        var document = select('./ns:DOCUMENT_SETS/ns:DOCUMENT_SET/ns:DOCUMENTS/ns:DOCUMENT', message, true);

        node = x.selectSingleNode(document, './ns:DEAL_SETS/ns:DEAL_SET/ns:DEALS/ns:DEAL/ns:SERVICES');
        if (node) 
            this.services = new Services(node);

        node = x.selectSingleNode(document, './ns:SIGNATORIES');
        if (node)
            this.signatories = new Signatories(node);

        nodes = x.selectNodes(document, './ns:VIEWS/ns:VIEW');
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.views.push(new View(xn));
            });
        }

        nodes = x.selectNodes(document, './ns:ABOUT_VERSIONS/ns:ABOUT_VERSION');
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.aboutVersions.push(new AboutVersion(xn));
            });
        }

        node = x.selectSingleNode(document, './ns:DOCUMENT_CLASSIFICATION');
        if (node) {
            this.documentClassification = new DocumentClassification(node);
        }
    }

    GetDocumentType() {
        if (this.documentClassification === null) return "Unknown";
        return this.documentClassification.GetDocumentType();
    }

    GetInspectorFileIdentifier() {
        if (!this.services) return null;
        if (!this.services.inspectionService) return null;
        return this.services.inspectionService.inspectorFileIdentifier;
    }
}

export class AboutVersion {
    constructor(doc)
    {
		this.label = null
		this.aboutVersionIdentifier = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.aboutVersionIdentifier = x.getStringElement(doc, "./ns:AboutVersionIdentifier");
   }
}

export class DocumentClass {
    constructor(doc)
    {
		this.label = null
		this.documentType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.documentType = x.getStringElement(doc, "./ns:DocumentType");
   }
}

export class DocumentClassificationDetail {
    constructor(doc)
    {
		this.label = null
		this.documentFormIssuingEntityNameType = null
		this.documentFormIssuingEntityVersionIdentifier = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.documentFormIssuingEntityNameType = x.getStringElement(doc, "./ns:DocumentFormIssuingEntityNameType");
		this.documentFormIssuingEntityVersionIdentifier = x.getStringElement(doc, "./ns:DocumentFormIssuingEntityVersionIdentifier");
   }
}

export class DocumentClassification {
    constructor(doc)
    {
		this.label = null
		this.documentClasses = []
		this.documentClassificationDetail = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:DOCUMENT_CLASSES/ns:DOCUMENT_CLASS");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.documentClasses.push(new DocumentClass(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:DOCUMENT_CLASSIFICATION_DETAIL");
		if (node !== null)
				this.documentClassificationDetail = new DocumentClassificationDetail(node);
    }

    GetDocumentType() {
        if (this.documentClasses.length === 0) return "Unknown";
        return this.documentClasses[0].documentType;
    }

}


